var _path, _path2, _circle, _circle2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEv00(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25.07,12.04c0-6.09-4.45-10.4-10.07-10.4S4.93,5.95,4.93,12.04c0,3.93,3.27,9.13,10.07,15.34,6.8-6.21,10.07-11.41,10.07-15.34ZM15,0c6.3,0,12,4.83,12,12.3,0,4.98-4.01,10.88-12,17.7C7.01,23.18,3,17.28,3,12.3,3,4.83,8.7,0,15,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15,5.43c-2.83,0-5.67.35-5.67,2.83v6.73c0,.67.27,1.28.71,1.73v1.46c0,.39.32.71.71.71h.71c.39,0,.71-.32.71-.71v-.71h5.67v.71c0,.39.32.71.71.71h.71c.39,0,.71-.32.71-.71v-1.46c.44-.45.71-1.06.71-1.73v-6.73c0-2.48-2.54-2.83-5.67-2.83Zm0,1.42c2.63,0,3.64.33,4.02.71h-7.97c.43-.37,1.45-.71,3.95-.71Zm4.25,7.8c0,.78-.64,1.42-1.42,1.42h-5.67c-.78,0-1.42-.64-1.42-1.42v-2.13h8.5v2.13Zm0-3.54h-8.5v-2.13h8.5v2.13Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.52,
    cy: 14.29,
    r: 1.06
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.48,
    cy: 14.29,
    r: 1.06
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m27.99,26.21h-1.52v-1.52c0-.42-.34-.76-.76-.76s-.76.34-.76.76v1.52h-1.52c-.42,0-.76.34-.76.76s.34.76.76.76h1.52v1.52c0,.42.34.76.76.76s.76-.34.76-.76v-1.52h1.52c.42,0,.76-.34.76-.76s-.34-.76-.76-.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEv00);
export default __webpack_public_path__ + "static/media/EV00.2dca1da71c86aad4b41f3540ed3162a1.svg";
export { ForwardRef as ReactComponent };